import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';

/** @category Entities and Profiles */
export function useProfile(profileId?: string) {
  const tokenizedApi = useTokenizedApi();
  const profiles = useQuery(tokenizedApi.entities.profilesQuery())?.data;

  if (!profileId) {
    return;
  }

  return profiles?.idMap?.get?.(profileId);
}
